@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.card {
  padding: 24px;
}

.list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.separator {
  display: block;
  margin: 24px 0;
  border: none;
}

.headline {
  font-family: "Instrument Serif";
  font-weight: 400;
  font-style: Regular;
  font-size: 28px;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--brand-indigo);
  margin: 0 0 12px;

  @include breakpoints.desktop {
    font-size: 32px;
    line-height: 140%;
    letter-spacing: 0%;
  }
}

.headlineSeparator {
  margin-bottom: 24px;
  border: none; // Unset default <hr> style
  border-bottom: 1px solid var(--blue-01-at-30);
}

.ctas {
  margin-top: 8px;
  text-align: center;
  margin-left: auto;
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  @include breakpoints.desktop {
    text-align: left;
    margin-left: var(--mobile-gutter);
    font-size: 16px;
  }
}

.inlineLink {
  font-family: typography.$font-mont;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;

  border: none;
  text-underline-offset: 2px;

  @include breakpoints.desktop {
    font-size: 16px;
  }

  &:hover {
    border: none;
    color: var(--highlight-blue);
  }
}

.mobileOnly {
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
}
